import { render, staticRenderFns } from "./kia.vue?vue&type=template&id=426a4903&"
import script from "./kia.vue?vue&type=script&lang=js&"
export * from "./kia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports